import AppModule from "../../services/App/AppModule.js";
import AppModuleAttr from "../../services/App/AppModuleAttr.js";
import AppModuleType from "../../services/App/AppModuleType.js";
import RouterModel from "../../router/RouterModel.js";

import StcdEx from "./Export/StcdEx.vue";
import StcdP from "./Print/StcdP.vue";
import StcdR from "./Report/StcdR.vue";

export default {
  Path: {
    Main: RouterModel.getPath(AppModule.StockCard),
    Export: RouterModel.getPath(AppModule.Item, AppModuleType.Export)
  },

  getRoutes() {
    return [
      {
        path: RouterModel.getPath(AppModule.StockCard, AppModuleType.Export),
        name: RouterModel.getName(AppModule.StockCard, AppModuleType.Export),
        component: StcdEx,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.StockCard, AppModuleType.Export),
          module: RouterModel.getModule(AppModule.StockCard),
          moduleattr: AppModuleAttr.StockCard_Act_Export,
          moduletype: AppModuleType.Export
        }
      },
      {
        path: RouterModel.getPath(AppModule.StockCard),
        name: RouterModel.getName(AppModule.StockCard),
        component: StcdR,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.StockCard),
          module: RouterModel.getModule(AppModule.StockCard),
          moduleattr: AppModuleAttr.StockCard_Act_Report,
          moduletype: AppModuleType.Report,
          // actions
          export: {
            module: RouterModel.getModule(AppModule.StockCard),
            moduleattr: AppModuleAttr.StockCard_Act_Report,
            moduletype: AppModuleType.Export
          },
          print: {
            module: RouterModel.getModule(AppModule.StockCard),
            moduleattr: AppModuleAttr.StockCard_Act_Print,
            moduletype: AppModuleType.Print
          }
        }
      }
    ];
  },

  getRootRoutes() {
    return [
      {
        path: RouterModel.getPath(AppModule.StockCard, AppModuleType.Print),
        name: RouterModel.getName(AppModule.StockCard, AppModuleType.Print),
        component: StcdP,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.StockCard, AppModuleType.Print),
          module: RouterModel.getModule(AppModule.StockCard),
          moduleattr: AppModuleAttr.StockCard_Act_Print,
          moduletype: AppModuleType.Print
        }
      }
    ];
  }
}